import { render } from "./TreeNode.vue?vue&type=template&id=891b47c0&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=891b47c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891b47c0"]])

export default __exports__